(() => {
  const root = document.querySelector('[data-hf-oct7-customize]');
  if (!root) return;
  const content = root.querySelector('[data-hf-oct7-content]');
  const labels = JSON.parse(content.querySelector('[data-oct7-i18n]').textContent);
  const dataURL = content.dataset.casesUrl;
  const imageURL = filename => filename ? new URL(filename, new URL(dataURL, location.href)).href : '';
  const text = (tag, value, className = '') => {
    const el = document.createElement(tag); el.textContent = value; el.className = className; return el;
  };
  const gallery = content.querySelector('[data-oct7-gallery]');
  let galleryItems = [], galleryIndex = 0, savedFocus;
  function galleryImage(item, url) {
    const image = new Image();
    image.dataset.oct7GalleryImage = '';
    image.width = 900; image.height = 1200;
    image.alt = item.title;
    image.decoding = 'async';
    image.src = url;
    return image;
  }
  async function showFullImage(preview, item) {
    const image = galleryImage(item, item.url);
    try { await image.decode(); } catch (_) { return; /* Keep the clicked preview if the full image cannot load. */ }
    // A closed/reopened dialog or newer selection must never receive an older load.
    if (gallery.open && preview.isConnected) preview.replaceWith(image);
  }
  function renderGallery() {
    const item = galleryItems[galleryIndex];
    gallery.querySelector('h2').textContent = item.title;
    // A fresh node cannot retain the previous image's decoded pixels while loading.
    const image = galleryImage(item, item.previewURL || item.url);
    gallery.querySelector('[data-oct7-gallery-image]').replaceWith(image);
    if (item.previewURL && item.previewURL !== item.url) showFullImage(image, item);
    gallery.querySelector('[data-oct7-gallery-note]').textContent = item.note || '';
    gallery.querySelector('[data-oct7-gallery-count]').textContent = `${galleryIndex + 1} / ${galleryItems.length}`;
    gallery.querySelectorAll('[data-oct7-prev], [data-oct7-next]').forEach(el => { el.disabled = galleryItems.length < 2; });
  }
  function openGallery(items, index = 0) {
    galleryItems = items.filter(item => item.url); if (!galleryItems.length) return;
    galleryIndex = Math.min(galleryItems.length - 1, Math.max(0, index)); savedFocus = document.activeElement; renderGallery(); gallery.showModal();
  }
  gallery.querySelector('[data-oct7-close]').addEventListener('click', () => gallery.close());
  gallery.addEventListener('close', () => savedFocus?.focus({ preventScroll: true }));
  gallery.addEventListener('click', e => { if (e.target === gallery) gallery.close(); });
  function move(delta) { galleryIndex = (galleryIndex + delta + galleryItems.length) % galleryItems.length; renderGallery(); }
  gallery.querySelector('[data-oct7-prev]').addEventListener('click', () => move(-1));
  gallery.querySelector('[data-oct7-next]').addEventListener('click', () => move(1));
  gallery.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1); } });
  const canShowOriginal = item => String(item.subject).trim().toLowerCase() === 'pet' && !item.hidden_original;
  const caseItems = item => ['original', 'preview', 'finished'].filter(stage => item.images[stage] && (stage !== 'original' || canShowOriginal(item))).map(stage => ({ url: imageURL(item.images[stage]), title: labels[stage] }));
  function photo(item, stage) {
    const figure = document.createElement('figure');
    if (!item.images[stage] || (stage === 'original' && !canShowOriginal(item))) { figure.append(text('div', labels.private, 'hf-oct7-private')); return figure; }
    const button = document.createElement('button'); button.type = 'button'; button.className = 'hf-oct7-photo';
    button.setAttribute('aria-label', `${labels[stage]} — ${labels.enlarge}`);
    const img = document.createElement('img'); img.src = imageURL(item.images[stage]); img.alt = labels[stage]; img.width = 720; img.height = 900; img.loading = 'lazy';
    button.append(img); button.addEventListener('click', () => { const items = caseItems(item); openGallery(items, items.findIndex(i => i.url === img.src)); });
    figure.append(button, text('figcaption', labels[stage]));
    return figure;
  }
  async function loadCases() {
    const feedback = content.querySelector('[data-oct7-feedback]');
    try {
      const cache = window.HugfigOct7CaseData ||= new Map();
      if (!cache.has(dataURL)) {
        const pending = fetch(dataURL, { credentials: 'omit' }).then(response => {
          if (!response.ok) throw new Error('cases');
          return response.json();
        }).catch(error => { cache.delete(dataURL); throw error; });
        cache.set(dataURL, pending);
      }
      const data = await cache.get(dataURL); const cases = data.cases;
      feedback.replaceChildren();
      for (const id of ['case-1144-01', 'case-1180-01', 'case-1146-01', 'case-1106-01']) {
        const c = cases.find(c => c.id === id); if (!c) continue;
        const card = document.createElement('article'); card.className = 'hf-oct7-feedback__card';
        const body = document.createElement('div');
        const stars = text('p', '★'.repeat(c.rating) + '☆'.repeat(5 - c.rating), 'hf-oct7-stars');
        stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', `${c.rating} / 5`);
        body.append(stars, text('blockquote', c.review));
        card.append(photo(c, 'finished'), body); feedback.append(card);
      }
    } catch (_) {
      const retry = text('button', labels.retry, 'hf-oct7-link'); retry.type = 'button'; retry.addEventListener('click', loadCases);
      feedback.replaceChildren(text('p', labels.error), retry);
    }
  }
  const config = root.querySelector('hugfig-rebuild-configurator');
  function customURL() {
    const url = new URL(location.href); url.searchParams.delete('step'); url.searchParams.delete('view');
    if (!url.searchParams.has('preview_theme_id') && window.Shopify?.theme?.id && window.Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    for (const key of ['product', 'type', 'style', 'size']) if (config?.selection?.[key]) url.searchParams.set(key, config.selection[key]);
    return url;
  }
  function updateLinks() {
    const from = customURL();
    root.querySelectorAll('[data-oct7-reviews]').forEach(link => {
      const url = new URL('/pages/customize', location.origin); url.searchParams.set('view', 'customer-reviews');
      for (const key of ['preview_theme_id', 'product', 'type', 'style', 'size', 'pb']) if (from.searchParams.has(key)) url.searchParams.set(key, from.searchParams.get(key));
      link.href = url.pathname + url.search;
    });
    content.querySelector('.hf-oct7-size__tip').classList.toggle('is-realistic', config?.selection?.style === 'realistic');
  }
  root.addEventListener('hf:selection-change', updateLinks);
  root.addEventListener('hf:variant-change', updateLinks);
  root.querySelectorAll('[data-oct7-reviews]').forEach(link => link.addEventListener('click', () => { updateLinks(); try { sessionStorage.setItem('hf-oct7-return', JSON.stringify({ url: customURL().href, scrollY: window.scrollY })); } catch (_) { /* Storage is optional. */ } }));
  const hero = root.querySelector('[data-hf-product-card]');
  const heroZoom = text('button', '', 'hf-oct7-hero-open'); heroZoom.type = 'button'; heroZoom.setAttribute('aria-label', labels.enlarge);
  heroZoom.addEventListener('click', () => { const img = hero.querySelector('[data-hf-product-image]'); if (img?.src) openGallery([{ url: img.currentSrc || img.src, title: hero.querySelector('[data-hf-product-name]').textContent }]); }); hero.querySelector('.hf-rb-product-card__image-wrap').append(heroZoom);
  const sizeImages = JSON.parse(content.querySelector('[data-oct7-size-images]').textContent).map(i => ({ ...i, title: `${i.title} · ${labels.size_original}` }));
  root.querySelectorAll('.hf-oct7-size__item').forEach((item, i) => { const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'hf-oct7-size__zoom'; btn.setAttribute('aria-label', sizeImages[i].title); while (item.firstChild) btn.append(item.firstChild); item.append(btn); btn.addEventListener('click', () => openGallery(sizeImages, i)); });
  for (const group of content.querySelectorAll('.hf-oct7-showcase__grid')) {
    const buttons = [...group.querySelectorAll('[data-oct7-showcase-photo]')];
    const items = buttons.map(button => ({ url: button.dataset.fullSrc, previewURL: button.querySelector('img').src, title: button.dataset.title, note: button.dataset.note }));
    for (const [index, button] of buttons.entries()) button.addEventListener('click', () => openGallery(items, index));
  }
  const approvalPhotos = [...content.querySelectorAll('[data-oct7-approval-photo]')];
  const approvalItems = approvalPhotos.map(button => ({ url: button.querySelector('img').src, title: button.dataset.title }));
  approvalPhotos.forEach((button, index) => button.addEventListener('click', () => openGallery(approvalItems, index)));
  updateLinks(); loadCases().then(restoreScroll);
  function restoreScroll() {
    if (new URLSearchParams(location.search).get('return_to_customize') !== '1') return;
    try { const saved = JSON.parse(sessionStorage.getItem('hf-oct7-return') || 'null'); if (saved && new URL(saved.url).origin === location.origin) { const restore = () => { if (document.body.dataset.oct7NavigationView !== 'reviews' && new URLSearchParams(location.search).get('view') !== 'customer-reviews') window.scrollTo({ top: saved.scrollY || 0, behavior: 'instant' }); }; requestAnimationFrame(restore); window.addEventListener('load', restore, { once: true }); } } catch (_) { /* Fall back to page top. */ }
  }
})();
